import type { ApiEndpoints } from '../types/ApiEndpoints';

const FILE_UPLOAD_ENDPOINT_KEYS: ReadonlySet<keyof ApiEndpoints> = new Set(['files']);

export const API_ENDPOINT_PATHS: Readonly<ApiEndpoints> = {
  login: '/api/v2/auth/login',
  register: '/api/v2/auth/register',
  verifyEmail: '/api/v2/auth/email/verify',
  forgotPassword: '/api/v2/auth/forgot-password',
  resetPassword: '/api/v2/auth/reset-password',
  googleLogin: '/api/v2/auth/google',
  discordLogin: '/api/v2/auth/discord',
  oauthRedirect: '/api/v2/auth/{provider}/redirect',
  oauthCallback: '/api/v2/auth/{provider}/callback',
  users: '/api/v2/users',
  currentUser: '/api/users/current',
  profiles: '/api/v2/profiles',
  profile: '/api/v2/users/me/profile',
  profileMedia: '/api/v2/users/me/profile-media',
  partnerProfiles: '/api/v2/partner-profiles',
  balloons: '/api/v2/balloons',
  search: '/api/search',
  searchV3: '/api/v3/search',
  metadata: '/api/metadata',
  partnersByUserLocation: '/api/partners-by-user-location',
  partners: '/api/v2/partners',
  appReleaseNotes: '/api/app-release-notes',
  files: '/api/files',
  region: '/api/region',
  regions: '/api/regions',
  balloonCollections: '/api/balloon-collections',
  drafts: '/api/drafts',
  bookmarks: '/api/v2/users/me/bookmarks',
  tags: '/api/v2/tags',
  categories: '/api/v2/categories',
  zeppelins: '/api/v2/zeppelins',
  banners: '/api/v2/banners',
  mapHotspots: '/api/v2/map/hotspots',
  savedSearches: '/api/v2/saved-search',
  assistantConversations: '/api/v2/assistant/conversations',
  assistantChat: '/api/v2/assistant/chat',
  embedConfig: '/api/v2/embed/config',
};

function trimTrailingSlash(value: string): string {
  return value.replace(/\/$/, '');
}

/**
 * Build absolute API endpoints from a base API hostname.
 */
export function buildApiEndpoints(
  hostName: string,
  fileUploadHostName?: string
): ApiEndpoints {
  const normalizedHost = trimTrailingSlash(hostName);
  const normalizedFileUploadHost = trimTrailingSlash(fileUploadHostName ?? hostName);
  const keys = Object.keys(API_ENDPOINT_PATHS) as (keyof ApiEndpoints)[];

  const endpoints = {} as ApiEndpoints;

  for (const key of keys) {
    const base = FILE_UPLOAD_ENDPOINT_KEYS.has(key)
      ? normalizedFileUploadHost
      : normalizedHost;

    endpoints[key] = `${base}${API_ENDPOINT_PATHS[key]}`;
  }

  return endpoints;
}
